import { GLTFLoader, DRACOLoader } from '@powerplay/common';
import { LoaderAssetRetryTypes } from './types';
import { cdnUrl } from './config';
export class Loader3D {
    assetsUrls = [];
    loader;
    assetsInfos;
    objects3DData = new Map();
    #assetsLoaded = 0;
    callbackBeforeLoad;
    dracoLoader;
    constructor(loadingManager, onPreloadComplete) {
        this.dracoLoader = new DRACOLoader()
            .setDecoderPath(`${cdnUrl}draco/new/`)
            .preload();
        this.loader = new GLTFLoader(loadingManager);
        this.loader.setDRACOLoader(this.dracoLoader);
        onPreloadComplete();
    }
    get assetsLoaded() {
        return this.#assetsLoaded;
    }
    set assetsLoaded(value) {
        this.#assetsLoaded = value;
    }
    setData(data) {
        this.assetsInfos = data;
    }
    loadAllAssets(callbackBeforeLoad) {
        this.callbackBeforeLoad = callbackBeforeLoad;
        for (const [key] of Object.entries(this.assetsInfos)) {
            this.loadAsset(key);
        }
    }
    loadAsset(assetName) {
        const data = this.assetsInfos[assetName];
        let assetNameToLoad = assetName;
        if (data.opponentCheck)
            assetNameToLoad = assetName.replace('_opponent', '');
        const url = `${data.dir}${assetNameToLoad}${data.version || ''}.${data.ext}`;
        this.assetsUrls.push({
            name: assetName,
            url,
            type: LoaderAssetRetryTypes.a3d
        });
        this.callbackBeforeLoad(assetName);
        this.loader.load(url, this.onLoadedAsset.bind(this, assetName, data.frustumNotCulled ?? false), () => {
        }, () => {
        });
    }
    onLoadedAsset(assetName, frustumNotCulled, object) {
        console.log(`nacitany 3d subor ${assetName}`, object);
        if (frustumNotCulled) {
            object.scene.traverse((objectItem) => {
                objectItem.frustumCulled = false;
            });
        }
        this.objects3DData.set(assetName, object);
        this.assetsLoaded += 1;
    }
}
//# sourceMappingURL=Loader3D.js.map